import { API } from "../apis/APIsConfig";

import Constants from "../utils/constants";

export function login(data) {
  return API.post(Constants.APIURLS.LOGIN, {
    tipo: data.type,
    userName: data.username,
    password: data.password
  });
} 

export function GetLoginFallos(Cedula) {
  return API.get(Constants.APIURLS.LOGINFALLOS + Cedula);
}
export function UpdateLoginFallos(Cedula, success) {
  return API.post(Constants.APIURLS.UPDATELOGINFALLOS + Cedula+"/"+success);
} 